import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userConfigWrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  userConfigContent: {
    '& > div + div': {
      marginTop: '16px',
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      '& button': {
        width: '100%',
      },
    },
  },
  viewItem: {
    boxShadow: 'none',
    padding: `${theme.spacing(0.5)} 0 !important`,
  },
  colorPreview: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    flexShrink: 0,
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
}));
